import { Tween, Easing } from '@tweenjs/tween.js';
// import { isDesktop } from 'react-device-detect';
export class TweenBonusRound {
	constructor(astronaut_in, astronaut_out, vc) {
		this.astronaut_in = astronaut_in;
		this.astronaut_out = astronaut_out;
		this.vc = vc;
		this.tween = null;
		this.tweenAstronaut = null;
		this.tweenItem = null;
	}
	animateAstronautTween() {
		this.astronaut_in.x = 75;
		this.astronaut_in.y = -40;
		this.astronaut_out.x = 75;
		this.astronaut_out.y = -40;
		this.astronaut_out.alpha = 0;
		this.astronaut_in.alpha = 1;
		this.astronaut_in.gotoAndPlay(0);
		this.tweenAstronaut = new Tween(this.astronaut_in)
			.to({ y: this.astronaut_in.y - 10, rotation: -0.08 }, 2000)
			.easing(Easing.Sinusoidal.InOut)
			.yoyo(true)
			.repeat(Infinity)
			.start();
	}

	moveAstronautTween(x, y, item) {
		this.astronaut_in.alpha = 0;
		this.astronaut_out.alpha = 1;
		this.astronaut_out.gotoAndPlay(0);
		this.astronaut_in.x = x;
		this.astronaut_in.y = y;
		setTimeout(() => {
			this.astronaut_in.x = x;
			this.astronaut_in.y = y;
			this.astronaut_out.x = x;
			this.astronaut_out.y = y;
			this.astronaut_in.alpha = 1;
			this.astronaut_in.gotoAndPlay(0);
			this.astronaut_out.alpha = 0;

			if (this.tweenAstronaut) {
				this.tweenAstronaut.stop();
				this.tweenAstronaut = new Tween(this.astronaut_in)
					.to({ y: this.astronaut_in.y - 10, rotation: -0.08 }, 2000)
					.easing(Easing.Sinusoidal.InOut)
					.yoyo(true)
					.repeat(Infinity)
					.start();
			}
			if (item.parent.config.name === 'bonus_item_3') {
				this.animateTexts(
					this.vc.BonusItems.bonus_item_holder.bonus_item_3.text_wrapper
				);
			}
			if (item.parent.config.name === 'bonus_item_6') {
				this.animateTexts(
					this.vc.BonusItems.bonus_item_holder.bonus_item_6.text_wrapper
				);
				// this.animateLstText(this.vc.BonusItems.bonus_item_holder.bonus_item_6.text_wrapper);
			}
		}, 150);
	}

	animateItemsTween(item) {
		this.tweenItem = new Tween(item)
			.to({ rotation: +0.2 }, 50)
			.yoyo(true)
			.repeat(5)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				new Tween(item.scale)
					.to({ x: 0, y: 0 }, 100)
					.easing(Easing.Linear.None)
					.start();
			})
			.start();
	}
	// animateLstText(item) {
	//   new Tween(item.scale)
	//     .to({ x: 1.5, y: 1.5 }, 200)
	//     .yoyo(true)
	//     .repeat(5)
	//     .easing(Easing.Linear.None)
	//     .onComplete(() => {
	//       new Tween(item.scale).to({ x: 0, y: 0 }, 200).easing(Easing.Back.None).start();
	//       new Tween(item).to({ alpha: 0 }, 200).easing(Easing.Linear.None).start();
	//     })
	//     .start();
	// }

	animateTexts(item) {
		new Tween(item)
			.to({ alpha: 0 }, 200)
			.yoyo(true)
			.repeat(5)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				new Tween(item)
					.to({ alpha: 0 }, 200)
					.easing(Easing.Linear.None)
					.start();
			})
			.start();
	}

	initBonusItemsTween(items) {
		const time = 1000;
		this.vc.win_bg_wrapper.win_bg.x = -10;
		this.vc.win_bg_wrapper.win_bg.y = -10;
		new Tween(this.vc.fg.scale)
			.to({ x: 1, y: 1 }, time)
			.delay(350)
			.easing(Easing.Back.InOut)
			.start();
		new Tween(this.vc.win_bg_wrapper)
			.to({ alpha: 1 }, time)
			.easing(Easing.Back.InOut)
			.delay(450)
			.start();
		new Tween(items.bonus_item_1)
			.to({ y: -20 }, time)
			.easing(Easing.Back.InOut)
			.start();
		new Tween(items.bonus_item_2)
			.to({ y: -50 }, time)
			.easing(Easing.Back.InOut)
			.delay(100)
			.start();
		new Tween(items.bonus_item_3)
			.to({ y: -70 }, time)
			.easing(Easing.Back.InOut)
			.delay(200)
			.start();
		new Tween(items.bonus_item_4)
			.to({ y: -20 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.start();
		new Tween(items.bonus_item_5)
			.to({ y: -40 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.start();
		new Tween(items.bonus_item_6)
			.to({ y: -60 }, time)
			.easing(Easing.Back.InOut)
			.delay(50)
			.onComplete(() => {
				window.connectionProvider.bonusRoundStep(
					JSON.stringify({
						service: 'bonusstep',
						data: {}
					})
				);
			})
			.start();
	}
}
